import { FC, memo } from 'react';
// import cn from 'clsx';
import type { Services } from '@framework/api/types';
import { ROUTE_SUBSCRIPTION, ROUTE_PRODUCT } from '@constants';
import { useRouter } from 'next/router';
import { useTranslation as t } from '@utils/hooks';
import NavItem from './NavItem';
import ServiceBadge from '../ServiceBadge';
import * as styles from './styles';

type Props = {
  slug: string;
  siblingSlug: string;
  regionalServices: Services;
};

const PurchaseOptionsNav: FC<Props> = ({
  slug,
  siblingSlug,
  regionalServices,
}) => {
  const router = useRouter();

  const [pathWithoutQuery] = router.asPath.split('?');

  const isActivePath = (path: string): boolean => pathWithoutQuery === path;

  if (!siblingSlug) {
    return null;
  }

  const BUY_LABEL = t('buy_nav_label');
  const BUY_SUBLABEL = t('buy_nav_sublabel');
  const LEASE_LABEL = t('lease_nav_label');
  const LEASE_SUBLABEL = t('lease_nav_sublabel');

  const getPath = (route: string): string =>
    isActivePath(`/${route}/${slug}`)
      ? `/${route}/${slug}`
      : `/${route}/${siblingSlug}`;

  const navigationItems = [
    {
      label: BUY_LABEL,
      sublabel: BUY_SUBLABEL,
      path: getPath(ROUTE_PRODUCT),
    },
    {
      label: LEASE_LABEL,
      sublabel: LEASE_SUBLABEL,
      path: getPath(ROUTE_SUBSCRIPTION),
    },
  ];
  return (
    <div className={styles.navWrapper}>
      <ul className={styles.nav}>
        {navigationItems.map(item => (
          <NavItem
            key={item.label}
            label={item.label}
            sublabel={item.sublabel}
            path={item.path}
            isActive={isActivePath(item.path)}
          />
        ))}
      </ul>
      {regionalServices && (
        <div className={styles.servicesWrapper}>
          {regionalServices?.bundlesPromos && (
            <ServiceBadge data={regionalServices?.bundlesPromos} />
          )}
          {regionalServices?.shippingNotices && (
            <ServiceBadge data={regionalServices?.shippingNotices} />
          )}
        </div>
      )}
    </div>
  );
};
export default memo(PurchaseOptionsNav);
